import { Input, Modal, Typography } from 'antd'
import { useState } from 'react'

export const BULK_TERMINATE_CONFIRM_TEXT = "I know what I'm doing"
export const BULK_TERMINATE_DESCRIPTION = 'Type the phrase to confirm:'
const MAX_LISTED_TARGETS = 10

interface Props {
  open: boolean
  title: string
  resourceName?: string
  targets?: string[]
  confirmText?: string
  description?: string
  onConfirm: () => Promise<void> | void
  onCancel: () => void
}

export function TerminateConfirmModal({
  open,
  title,
  resourceName,
  targets,
  confirmText,
  description,
  onConfirm,
  onCancel,
}: Props) {
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)

  const expectedText = confirmText ?? resourceName ?? ''
  const isMatch = input === expectedText

  const handleOk = async () => {
    if (!isMatch) return
    setLoading(true)
    try {
      await onConfirm()
    } finally {
      setLoading(false)
      setInput('')
    }
  }

  const handleCancel = () => {
    setInput('')
    onCancel()
  }

  return (
    <Modal
      title={title}
      open={open}
      onOk={() => void handleOk()}
      onCancel={handleCancel}
      okText="Terminate"
      okType="danger"
      okButtonProps={{ disabled: !isMatch }}
      confirmLoading={loading}
      destroyOnHidden
    >
      {targets && targets.length > 0 && (
        <ul data-testid="terminate-targets">
          {targets.slice(0, MAX_LISTED_TARGETS).map((t, i) => (
            <li key={`${t}-${i}`}>{t}</li>
          ))}
          {targets.length > MAX_LISTED_TARGETS && (
            <li>+{targets.length - MAX_LISTED_TARGETS} more</li>
          )}
        </ul>
      )}
      <p>
        {description ?? 'Type the name to confirm:'}{' '}
        <Typography.Text copyable strong>
          {expectedText}
        </Typography.Text>
      </p>
      <Input
        placeholder={expectedText}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        status={input && !isMatch ? 'error' : undefined}
      />
    </Modal>
  )
}
